const {
    Glide,
    Controls,
    Swipe,
    Breakpoints,
    Images,
    Autoplay,
    Keyboard
} = window.glidejs;

export {
    Glide,
    Controls,
    Swipe,
    Breakpoints,
    Images,
    Autoplay,
    Keyboard
};